import { Component } from "@angular/core";

@Component({
    selector: "vo-logo",
    templateUrl: "./logo.component.html",
    host: {
        class: "inline-block text-16 leading-dense"
    }
})
export class LogoComponent {}
